import { call, put } from 'redux-saga/effects';
import {
  deleteExcelTransactionsFileFailure,
  deleteExcelTransactionsFileSuccess,
  fetchExcelFilesMetadataRequest,
  fetchAllExcelTransactionsRequest,
} from '../actions';
import { deleteExcelTransactionsFile } from '../api';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { DeleteExcelTransactionsFileRequestAction } from '../types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* deleteExcelTransactionsFileSaga(
  action: DeleteExcelTransactionsFileRequestAction
) {
  try {
    const { organisationId, importId } = action.payload;

    const deleteResponse: ApiResponse = yield call(
      deleteExcelTransactionsFile,
      organisationId,
      importId
    );

    const err: ApiError | null = checkResponse(deleteResponse?.responseMessage);
    if (err) throw err;
    const message: MessageData = {
      title: i18n.t('common.success'),
      description: deleteResponse.responseMessage.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(deleteExcelTransactionsFileSuccess());
    yield put(fetchExcelFilesMetadataRequest(organisationId));
    // Refresh transactions list from saga so frontend doesn't double-fetch
    const { refreshParams } = action.payload;
    if (refreshParams) {
      yield put(
        fetchAllExcelTransactionsRequest(
          organisationId,
          refreshParams.page,
          refreshParams.pageSize,
          refreshParams.filters
        )
      );
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(deleteExcelTransactionsFileFailure());
  }
}
